module.exports = __webpack_public_path__ + "static/media/arrow-down2.6e4884a6.svg";